import PropTypes from 'prop-types'
import React from 'react'
import {SHIPPING_THRESHOLD} from '../../const'

import '../../../scss/components/_line-item-tooltip-label.scss'

export const DAMAGE_WAIVER_TOOLTIP_TEXT =
  'Non-refundable charge for the ' +
  'costs of normal wear and tear. See our rental agreement for details.'
export const SHIPPING_TOOLTIP_TEXT = `FREE shipping on orders over ${SHIPPING_THRESHOLD}.`

const LineItemTooltipLabel = ({label, tooltipText}) => (
  <span className="line-item-tooltip-label">
    {label}
    <div className="line-item-tooltip-content">{tooltipText}</div>
  </span>
)

LineItemTooltipLabel.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipText: PropTypes.string,
}

export default LineItemTooltipLabel
